import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';
import { ImportModalTypes } from '../components/Modals/ImportModalTypes.ts';
import { DocExceededSizeLimit } from '../utils/fileValidation.ts';
import { FILE_UPLOAD_LIMIT } from '../config/fileUploadLimit.ts';
import { fixedBytesToMegabytes } from '../utils/fixedBytesToMegabytes.ts';

export const useFileSizeCheck = (): ((document: { name: string; size: number }) => boolean) => {
	const { showModal } = useContext(ImportStateContext);

	return useCallback(
		(document: { name: string; size: number }): boolean => {
			if (DocExceededSizeLimit(document.size, FILE_UPLOAD_LIMIT)) {
				showModal(ImportModalTypes.FILE_SIZE, {
					fileName: document.name,
					fileSize: fixedBytesToMegabytes(document.size),
				});
				return false;
			}

			return true;
		},
		[showModal],
	);
};
